<form class="checkbox-container" [formGroup]="form">
  <label nz-checkbox formControlName="hideRestricted">Hide Restricted Products <i nz-icon  nz-tooltip nzTitle="Hide products that cannot be purchased until you sign an agreement with the supplier" nzType="info-circle" nzTheme="outline"></i></label>
</form>
